// FacebookAdPASPage.js
import React from 'react';
import ElaborateFooter from '../../../common/ElaborateFooter';
import Header from '../../../common/Header';

const FacebookAdPASPage = () => {
  return (
    <>
      <Header />
      <div className="max-w-4xl mx-auto p-8 bg-white rounded-lg">
        {/* Add back button */}
        <div className="flex items-center mb-8">
          <button 
            onClick={() => window.location.href = '/templates'}
            className="text-indigo-600 text-md"
          >
            &larr; Back to templates
          </button>
        </div>
        <h1 className="text-3xl text-indigo-600">Facebook Ad (PAS)</h1>
        {/* Overview section */}
        <section className="mb-8 mt-8">
          <h2 className="text-2xl text-indigo-600 mb-4">Overview</h2>
          <p>Create compelling Facebook ads using the PAS (Problem-Agitate-Solution) framework. Address your audience's pain points, agitate their emotions, and present your product or service as the solution.</p>
        </section>
        {/* Key features section */}
        <section className="mb-8">
          <h2 className="text-2xl text-indigo-600 mb-4">Key Features</h2>
          <ul className="list-disc list-inside">
            <li><strong>Problem Identification:</strong> Identify your audience's pain points and challenges.</li>
            <li><strong>Emotional Appeal:</strong> Agitate emotions to create a sense of urgency and need.</li>
            <li><strong>Solution Presentation:</strong> Present your product or service as the solution to their problems.</li>
          </ul>
        </section>
        {/* How It Works section */}
        <section className="mb-8">
          <h2 className="text-2xl text-indigo-600 mb-4">How It Works</h2>
          <div>
            <h3 className="text-xl text-indigo-500 mb-2">1. Identify the Problem</h3>
            <p>Highlight a common problem or pain point experienced by your target audience.</p>
            <h3 className="text-xl text-indigo-500 mb-2">2. Agitate Emotions</h3>
            <p>Agitate their emotions by emphasizing the negative consequences of not solving the problem.</p>
            <h3 className="text-xl text-indigo-500 mb-2">3. Present the Solution</h3>
            <p>Introduce your product or service as the ultimate solution to their problems.</p>
          </div>
        </section>
        {/* Benefits section */}
        <section className="mb-8">
          <h2 className="text-2xl text-indigo-600 mb-4">Benefits</h2>
          <ul className="list-disc list-inside">
            <li><strong>Increased Conversions:</strong> Engage with your audience on an emotional level to drive action.</li>
            <li><strong>Targeted Messaging:</strong> Address specific pain points to resonate with your audience.</li>
            <li><strong>Effective Storytelling:</strong> Tell a compelling story that captures attention and inspires action.</li>
          </ul>
        </section>
        {/* Use Cases section */}
        <section className="mb-8">
          <h2 className="text-2xl text-indigo-600 mb-4">Use Cases</h2>
          <ul className="list-disc list-inside">
            <li><strong>Product Launch:</strong> Introduce new products or services by addressing customer needs.</li>
            <li><strong>Lead Generation:</strong> Generate leads by addressing pain points and offering solutions.</li>
            <li><strong>Brand Awareness:</strong> Build brand awareness by resonating with your audience's emotions.</li>
          </ul>
        </section>
        {/* Use This Template section */}
        <section>
          <h2 className="text-2xl text-indigo-600 mb-4">Use This Template</h2>
          <p className="mt-4"><a className="text-md text-indigo-600" href="https://app.graphia.ai">Sign up</a> & get started</p>
        </section>
      </div>
      <ElaborateFooter />
    </>
  );
};

export default FacebookAdPASPage;
